import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Link from '../Link/Link';

import './ButtonCTA.module.css';

class ButtonCTA extends PureComponent {
  render() {
    const { children, color, url, arrow, ...rest } = this.props;
    return (
      <Link
        to={url}
        styleName={classNames('default-button', `${color}`, `${arrow}`)}
        {...rest}
      >
        {children}
      </Link>
    );
  }
}

ButtonCTA.propTypes = {
  url: PropTypes.string,
  arrow: PropTypes.oneOf(['left', 'right', 'none']),
  color: PropTypes.oneOf(['dark', 'light']),
  children: PropTypes.node
};

ButtonCTA.defaultProps = {
  arrow: 'none',
  color: 'dark'
};

export default ButtonCTA;
